import styled, { useTheme } from 'styled-components'
import { Text } from 'components/atoms/Text'
import { ValuesBar } from './ValuesBar'
import { AssetStatistic } from './AssetStatistic'
import { getAssetItems } from './utils/getAssetItems'
import { TokenStatistic } from 'components/molecules/Statistic'
import { CurrencyValue, Token } from '@usedapp/core'
import { Row } from 'components/atoms/Row'
import { OfferingIdentifier } from 'types'

export interface Props extends OfferingIdentifier {
  totalAssets: CurrencyValue
  liquidAssets: CurrencyValue
  outstandingPrincipal: CurrencyValue
  outstandingInterest: CurrencyValue
  newTotalValue?: CurrencyValue
  newLiquidAssetsValue?: CurrencyValue
  newOutstandingPrincipalValue?: CurrencyValue
  newOutstandingInterestValue?: CurrencyValue
  view?: 'column' | 'row'
  showNoChange?: boolean
}

export const AssetComposition = ({
  totalAssets,
  liquidAssets,
  outstandingPrincipal,
  outstandingInterest,
  newTotalValue,
  newLiquidAssetsValue,
  newOutstandingPrincipalValue,
  newOutstandingInterestValue,
  view,
  showNoChange,
}: Props) => {
  const theme = useTheme()
  const assetItems = getAssetItems(liquidAssets, outstandingPrincipal, outstandingInterest, theme)
  const newValueMap: Record<string, CurrencyValue | undefined> = {
    'Liquid Assets': newLiquidAssetsValue || liquidAssets,
    'Outstanding Principal': newOutstandingPrincipalValue || outstandingPrincipal,
    'Outstanding Interest': newOutstandingInterestValue || outstandingInterest,
  }

  return (
    <Container>
      <Text bold color="dark">
        Asset Composition:
      </Text>
      <Row>
        <TokenStatistic
          value={totalAssets.value}
          newValue={newTotalValue}
          token={totalAssets.currency as Token}
          label="Total Offering Value"
          variant="title3"
          placeholder="N/A"
          extraBold
          withTicker
          view="column"
          overriderFormatOptions={{ fixedPrecisionDigits: 2, useFixedPrecision: true }}
        />
      </Row>
      <ValuesBar items={assetItems} />
      {assetItems.map(({ label, value, tooltip, color }) => (
        <AssetStatistic
          view={view}
          key={label}
          label={label}
          value={value}
          tooltip={tooltip}
          color={color}
          newValue={newValueMap[label]}
          showNoChange={showNoChange}
        />
      ))}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
